// Module
var code = `<div class="alertPanelSideBar" on-mousedown="@this.onMouseDown(event)" on-contextmenu="@this.onContextMenuOpen(event)">
    <div class="alertPanelSideBar-body" {{#if .alertsArray.length===0}}style="display: none;"{{/if}}>
        <div class="alertPanelSideBar-item-container">
            {{#each alertsArray: i}}
                <alertItemSideBar alert="{{alertsArray[i]}}" on-actionClick="onAlertAction" />
            {{/each}}
        </div>
    </div>

    {{#if .alertsArray.length===0}}
        {{>noData}}
    {{/if}}

    <div class="alertPanelSideBar-bottom">
        <terceraButton name="alerts" SVG="true"
                       text="{{.btnText}}"
                       tooltip="{{.canAddAlert ? .btnTooltip : .btnDisabledTooltip}}"
                       enabled="{{.canAddAlert}}"
                       on-btnClick="onAddClick" 
                       terceraButtonStyle="js-button-blue"/>
    </div>
</div>
{{#if createAlertPanelOpened}}
    <CreateAlertPanel initAlert="{{alertForEditing}}"
                        on-windowCloseCallback="onCreateAlertClosed"/>
{{/if}}`;
// Exports
export default code;